
import { Component, Vue } from 'vue-property-decorator';
import DeviceLayout from '../../layouts/DeviceLayout.vue';
import PcPage from '../../blocks/PcPage.vue';
import MobilePage from '../../blocks/MobilePage.vue';
import { collectPageView } from '@/config/collect';
import { DEFAULT_DOWNLOAD_URLS } from '../../config/downloadUrls';
import { LandingProps } from '../../config/types';

@Component({
  components: { DeviceLayout, PcPage, MobilePage },
})
export default class DefaultPage extends Vue {
  public landingProps: LandingProps = {
    downloadUrls: DEFAULT_DOWNLOAD_URLS,
    hideList: true,
    collectEnabled: true,
    iosChannelEnabled: true,
    showAppInfo: false,
    isBaiduDeveloper: false,
    showAddress: true,
    // 视频地址待确认，确认后替换
    videoSrc: require('@/assets/video/rj02.mp4'),
    showIosDownload: true,
    customVideoButtons: true,
  };

  public mounted() {
    if (this.landingProps.collectEnabled) {
      collectPageView();
    }
  }
}
